module.exports = __webpack_public_path__ + "img/sdg_pt-pt_(16).bbc02238.png";